import React from 'react';

export interface UserEmail {

}

export const UserEmail = (props: { email: React.ReactNode; }) => {
    return (
        <a className={'user-item__email'}>{props.email}</a>
    )
}
